<template>
    <div class="form-box">
        <div class="form-title text-center">
            设置支付密码
        </div>
        <div class="form-content">
            <el-form label-width="100px">
                <el-form-item label="新密码">
                    <el-input type="password" v-model="password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="">
                    6-16位英文字母、数字或_，不能与登录密码重复
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ck_password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
export default {
    name: 'Step1',
    data () {
        return {
            password: '',
            ck_password: ''
        }
    },
    mounted () {

    },
    methods: {
        submitForm () {
            if (this.password === '') {
                this.$message.error('请输入新的支付密码')
            } else if (!(/^[a-zA-Z0-9_]{6,18}$/.test(this.password))) {
                this.$message.error('支付密码由6-18位的数字、字母和_组成')
            } else if (this.ck_password !== this.password) {
                this.$message.error('两次输入的支付密码不一致')
            } else {
                this.$http.post('/api/user/resetpaypwd', qs.stringify({
                    step: 2,
                    password: this.password,
                    ck_password: this.ck_password
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$message.success('支付密码设置成功')
                            router.replace('/index/info/safe')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
